export type AutosizeTextareaConfig = {
  minRows: number;
  maxRows: number;
};

export function autosizeTextarea(
  el: HTMLElement,
  config: AutosizeTextareaConfig
): void {
  const cs = getComputedStyle(el);
  const fontSize = parseFloat(cs.fontSize);
  const rawLineHeight = parseFloat(cs.lineHeight);
  const lineHeight = Number.isFinite(rawLineHeight)
    ? rawLineHeight
    : fontSize * 1.4;
  const padY = parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
  const borderY =
    parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);

  // Assumes border-box so heights below include padding + border.
  const minH = lineHeight * config.minRows + padY + borderY;
  const maxH = lineHeight * config.maxRows + padY + borderY;

  el.style.height = "auto";
  const desired = el.scrollHeight + borderY;
  const next = Math.min(maxH, Math.max(minH, desired));
  el.style.height = `${next}px`;
  el.style.overflowY = desired > maxH ? "auto" : "hidden";
}
